import CryptoJS from "crypto-js";
class DataEncryptorClass {
    constructor() {
        this.key = CryptoJS.enc.Utf8.parse('4512639636589784');
        this.iv = CryptoJS.enc.Utf8.parse('4512639636589784');
    }
    // Accept either a string or a CipherParams object
    decrypt(decString, isJson = true) {
        if (!decString)
            return null;
        try {
            const decrypted = CryptoJS.AES.decrypt(decString, this.key, {
                keySize: 128 / 8,
                iv: this.iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
            return isJson ? JSON.parse(decryptedString) : decryptedString;
        }
        catch (ex) {
            return null;
        }
    }
    // Return CipherParams object from encrypt
    encrypt(userData) {
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(userData)), this.key, {
            keySize: 128 / 8,
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted; // Keep it as CipherParams
    }
}
export const DataEncryptor = new DataEncryptorClass();
